import { Provider } from "jotai/react";

import { memo } from "react";

import { Toaster } from "sileo";

import "./internalization";

import Routes from "./Routes";

import { store } from "./lib/store";

import { ErrorBoundary } from "./components/ErrorBoundary";

import { OfflineBanner } from "./components/OfflineBanner";

import { PWAUpdatePrompt } from "./components/PWAUpdatePrompt";

const Root = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <Toaster
          position="top-center"
          options={{
            fill: "#1e1e2e",
            styles: { description: "color: #e0e0e0" },
          }}
        />
        <OfflineBanner />
        <PWAUpdatePrompt />
        <Routes />
      </Provider>
    </ErrorBoundary>
  );
};

export default memo(Root);
